import { DefaultModelProperty, LabelValue } from '../standard'
import ReleaseZone from './release-zone-model'
import releaseZoneProperties from './releaseZone-properties'
import { ReleaseZoneProperties } from './releaseZone-property-definitions'

import { Language } from '../enumerations'
export async function OnEvents(
  eventType: string,
  form: ReleaseZone,
  property: ReleaseZoneProperties,
): Promise<ReleaseZone> {
  switch (eventType) {
    case 'change':
      return await change(property, form)

    default:
      break
  }
  return form
}
export function IsDisabled(property: ReleaseZoneProperties): boolean {
  switch (property) {
    default:
      return false
  }
}

export function IsVisible(property: ReleaseZoneProperties): boolean {
  switch (property) {
    case ReleaseZoneProperties.IsRelease:
      return false
    case ReleaseZoneProperties.Owner:
      return false
    case ReleaseZoneProperties.Id:
      return false
    case ReleaseZoneProperties.Created:
      return false
    case ReleaseZoneProperties.Updated:
      return false
    case ReleaseZoneProperties.Deleted:
      return false
    case ReleaseZoneProperties.Version:
      return false
    default:
      return true
  }
}
async function change(
  property: ReleaseZoneProperties,
  value: ReleaseZone,
): Promise<ReleaseZone> {
  switch (property) {
    default:
      return value
  }
  return value
}
function getModelProperties(): DefaultModelProperty<ReleaseZoneProperties>[] {
  return releaseZoneProperties as DefaultModelProperty<ReleaseZoneProperties>[]
}
export function GetPageProperties(): DefaultModelProperty<ReleaseZoneProperties>[] {
  function getPagePropertyPosition(property: string) {
    switch (property) {
      default:
        return 20
    }
  }
  return AssignUIComponent(
    getModelProperties()
      .filter((x: DefaultModelProperty<ReleaseZoneProperties>) => {
        return getPagePropertyPosition(x.name) !== -1
      })
      .sort((a, b) => {
        return getPagePropertyPosition(a.name) - getPagePropertyPosition(b.name)
      })
      .map((v: DefaultModelProperty<ReleaseZoneProperties>) => {
        return v
      }),
  )
}

export function DropdownOptions(
  property: ReleaseZoneProperties,
): LabelValue<any>[] {
  switch (property) {
    case ReleaseZoneProperties.Language:
      return Object.entries(Language).map((v) => {
        return {
          label: v[0],
          value: v[1],
        }
      })
    default:
      return []
      break
  }
  return []
}
export function IsRequired(property: ReleaseZoneProperties): boolean {
  switch (property) {
    case ReleaseZoneProperties.IsRelease:
      return false
    case ReleaseZoneProperties.Owner:
      return false
    case ReleaseZoneProperties.Id:
      return false
    case ReleaseZoneProperties.Created:
      return false
    case ReleaseZoneProperties.Updated:
      return false
    case ReleaseZoneProperties.Deleted:
      return false
    case ReleaseZoneProperties.Version:
      return false
    default:
      return true
  }
}
export function AssignUIComponent(
  properties: DefaultModelProperty<ReleaseZoneProperties>[],
): DefaultModelProperty<ReleaseZoneProperties>[] {
  return properties.map(
    (modelProperty: DefaultModelProperty<ReleaseZoneProperties>) => {
      switch (modelProperty.name) {
        default:
          break
      }
      return modelProperty
    },
  )
}
